import { render } from "./ScaleLoader.vue?vue&type=template&id=055c6bf4"
import script from "./ScaleLoader.vue?vue&type=script&lang=js"
export * from "./ScaleLoader.vue?vue&type=script&lang=js"

import "./ScaleLoader.vue?vue&type=style&index=0&id=055c6bf4&lang=css"

import exportComponent from "/home/forge/crm.thebcr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__